import {z} from 'zod'
import {ResponseType} from '@/types.ts'
import {Assignment} from '@features/assignment/types.ts'

export const AssignmentsURLParams = z.object({
    page: z.coerce.number().int().positive().default(1),
    search: z.string().optional(),
    filter_by: z.enum(['status']).default('status'),
    filter_value: z
        .enum(['coordination', 'pending_submission', 'needs_more_assets', 'upcoming', 'completed'])
        .default('coordination'),
    order_by: z
        .enum([
            'title',
            'address',
            'first_name',
            'host_availability_dates',
            'coordination_status',
            'accepted_at',
            'status',
            'assets_rejected_at',
            'declined_reason_notes',
            'to_shoot_at',
            'completed_at',
            'amount'
        ])
        .optional(),
    order_direction: z.enum(['asc', 'desc']).optional(),
    hide_cancelled: z.enum(['true', 'false']).default('true')
})
export type AssignmentsURLParams = z.infer<typeof AssignmentsURLParams>

export const AssignmentsSearchParams = z.object({
    ...AssignmentsURLParams.shape,
    limit: z.coerce.number().int().positive().default(15),
    response_type: ResponseType.optional()
})
export type AssignmentsSearchParams = z.infer<typeof AssignmentsSearchParams>

const TableCountersSearchParams = AssignmentsSearchParams.pick({search: true, response_type: true})
export type TableCountersSearchParams = z.infer<typeof TableCountersSearchParams>

export const RequiredActions = z.object({
    new_assignments: z.array(
        Assignment.pick({
            total_amount: true,
            code: true,
            entity: true
        })
    ),
    is_calendar_disconnected: z.boolean(),
    host_shared_dates: z.array(Assignment.pick({code: true, entity: true})),
    deliverable_issue: z.array(Assignment.pick({code: true, entity: true})),
    late_delivery: z.array(Assignment.pick({code: true, entity: true})),
    coordination_overdue: z.array(Assignment.pick({code: true, entity: true})),
    has_new_insights: z.boolean(),
    is_introducing_missing: z.boolean(),
    is_calendar_connected: z.boolean()
})
export type RequiredActions = z.infer<typeof RequiredActions>

export const TableCounters = z.object({
    coordination_assignments_count: z.number(),
    needs_more_assets_assignments_count: z.number(),
    completed_assignments_count: z.number(),
    upcoming_assignments_count: z.number(),
    pending_submission_assignments_count: z.number()
})
export type TableCounters = z.infer<typeof TableCounters>
